export default __webpack_public_path__ + "fe1c6782ef005f8e32ae0acdeaa3f6a3.png";